<template>
  <DragDialog
    :title="`${roleInfo ? '编辑' : '新增'}角色`"
    :width="800"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel"
  >

    <el-form
      class="common-form-box public-form-primary"
      :model="form"
      :rules="rules"
      label-width="100px"
      ref="form"
    >
      <el-form-item label="角色名称:" prop="roleName">
        <div class="common-input-box">
          <el-input
          class="input-primary"
            size="small"
            v-model="form.roleName"
            placeholder="请输入角色名称"
          />
          <div class="tip-box public-tips-primary">
            2-20位字符，中英文开头，支持汉字、字母、下划线
          </div>
        </div>
      </el-form-item>
      <el-form-item label="角色编码:" :class="roleInfo?'no-distance':''" prop="roleCode">
        <div class="common-input-box" v-if="!(roleInfo && roleInfo.roleId)">
          <el-input
          class="input-primary"
            size="small"
            v-model="form.roleCode"
            placeholder="请输入角色编码"
          />
          <div class="tip-box public-tips-primary">具有唯一性且必须是英文</div>
        </div>
        <div class="edit-role" v-else>
          {{ roleInfo.roleCode }}
        </div>
      </el-form-item>
      <el-form-item label="角色级别:" prop="roleLevel">
        <div class="common-select-box">
          <el-select
          class="primary-select"
            size="small"
            v-model="form.roleLevel"
            placeholder="请选择角色级别"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="(item, index) in roleLevelList"
              :key="index"
              :label="item.displayName"
              :value="item.value"
            />
          </el-select>
          <div class="tip-box public-tips-primary">级别会影响可操作的角色范围、用户范围</div>
        </div>
      </el-form-item>
      <el-form-item label="角色范围:" prop="roleScope">
        <div class="common-select-box">
          <el-select
          class="primary-select"
            size="small"
            v-model="form.roleScope"
            placeholder="请选择角色范围"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="(item, index) in roleScopeList"
              :key="index"
              :label="item.displayName"
              :value="item.value"
            >
              <div class="option-box">
                <div class="option-name">{{ item.displayName }}</div>
                <div class="option-tip">{{ `(${item.tip})` }}</div>
              </div>
            </el-option>
          </el-select>
          <div class="tip-box public-tips-primary">根据角色的级别，显示可操作的用户角色</div>
        </div>
      </el-form-item>
      <el-form-item label="用户范围:" prop="userScope">
        <div class="common-select-box">
          <el-select
          class="primary-select"
            size="small"
            v-model="form.userScope"
            placeholder="请选择用户范围"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="(item, index) in userScopeList"
              :key="index"
              :label="item.displayName"
              :value="item.value"
            >
              <div class="option-box">
                <div class="option-name">{{ item.displayName }}</div>
                <div v-if="item.value !== 3" class="option-tip">
                  {{ `(${item.tip})` }}
                </div>
                <div v-if="item.value === 3" class="option-tip">
                  <span>{{ `(${item.tip}` }}</span>
                  <span class="option-link" @click="jumpToTeamManage">
                    团队管理
                  </span>
                  <span>)</span>
                </div>
              </div>
            </el-option>
          </el-select>
          <div class="tip-box public-tips-primary">角色可管理的用户数据范围</div>
        </div>
      </el-form-item>
      <el-form-item label="项目范围:" prop="projScope">
        <div class="common-select-box">
          <el-select
          class="primary-select"
            size="small"
            v-model="form.projScope"
            placeholder="请选择项目范围"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="(item, index) in projScopeList"
              :key="index"
              :label="item.displayName"
              :value="item.value"
            >
              <div class="option-box">
                <div class="option-name">{{ item.displayName }}</div>
                <div class="option-tip">{{ `(${item.tip})` }}</div>
              </div>
            </el-option>
          </el-select>
          <div class="tip-box public-tips-primary">角色可管理的项目数据范围</div>
        </div>
      </el-form-item>
      <el-form-item label="构件范围:" prop="entityScope">
        <div class="common-select-box">
          <el-select
          class="primary-select"
            size="small"
            v-model="form.entityScope"
            placeholder="请选择构件范围"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in entityScopeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <div class="option-box">
                <div class="option-name">{{ item.label }}</div>
                <div class="option-tip">{{ `(${item.tip})` }}</div>
              </div>
            </el-option>
          </el-select>
          <div class="tip-box public-tips-primary">角色可管理的构件数据范围</div>
        </div>
      </el-form-item>
      <el-form-item label="角色说明:" class="role_desc" prop="description">
        <el-input
        class="input-primary"
          type="textarea"
          :rows="5"
          v-model="form.description"
          placeholder="添加角色说明，便于记忆哦"
        />
      </el-form-item>
      <el-form-item label="设为默认角色:" v-if="isSuperAdmin()">
        <div class="common-switch-box">
          <el-switch class="switch-primary" v-model="form.isDefault" />
        </div>
        <div class="tip-box public-tips-primary">
          设为默认角色:创建用户时,如果不指定角色,分配给用户的默认角色
        </div>
      </el-form-item>
    </el-form>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";

import { Store } from "@/utils/store";

import {
  createRoleService,
  updateRoleService,
  getRoleLevelListService,
  getRoleScopeListService,
  getUserScopeListService,
  getProjScopeListService,
} from "@/service/interface";

export default {
  data() {
    return {
      form: {
        roleName: "",
        roleCode: "",
        roleLevel: undefined,
        roleScope: undefined,
        userScope: undefined,
        projScope: undefined,
        entityScope: undefined,
        isDefault: undefined,
        description: "",
      },
      roleLevelList: [],
      roleScopeList: [],
      userScopeList: [],
      projScopeList: [],
      entityScopeList: [
        { value: 1, label: "所有构件", tip: "管理系统内公共构件和我的构件" },
        {
          value: 2,
          label: "我的构件",
          tip: "管理系统内我的构件，仅可查询可用的公共构件",
        },
      ],
      rules: {
        roleName: [
          {
            required: true,
            message: "请输入角色名称",
            trigger: "blur",
          },
          {
            pattern: /^[\u4e00-\u9fa5a-zA-Z][\u4e00-\u9fa5a-zA-Z0-9_]{1,19}$/,
            message: "2-20位字符, 中英文开头, 支持汉字、字母、下划线",
            trigger: "blur",
          },
        ],
        roleCode: [
          {
            required: true,
            message: "请输入角色编码",
            trigger: "blur",
          },
          {
            pattern: /^[a-zA-Z]+$/,
            message: "角色编码必须是英文",
            trigger: "blur",
          },
        ],
        roleLevel: [
          {
            required: true,
            message: "请选择角色级别",
            trigger: "change",
          },
        ],
        roleScope: [
          {
            required: true,
            message: "请选择角色范围",
            trigger: "change",
          },
        ],
        userScope: [
          {
            required: true,
            message: "请选择用户范围",
            trigger: "change",
          },
        ],
        projScope: [
          {
            required: true,
            message: "请选择项目范围",
            trigger: "change",
          },
        ],
        entityScope: [
          {
            required: true,
            message: "请选择构件范围",
            trigger: "change",
          },
        ],
        description: [
          {
            required: true,
            message: "请输入角色说明",
            trigger: "blur",
          },
        ],
      },
    };
  },
  props: {
    visible: Boolean,
    roleInfo: Object,
    updateRoleList: Function,
    closeDialog: Function,
  },
  components: {
    DragDialog,
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initSelectOption().then(() => {
          this.initForm();
        });
      }
    },
  },
  methods: {
    initSelectOption() {
      return new Promise((resolve) => {
        let promiseArray = [];
        promiseArray.push(this.queryRoleLevelList());
        promiseArray.push(this.querRoleScopeList());
        promiseArray.push(this.queryUserScopeList());
        promiseArray.push(this.queryProjScopeList());
        Promise.all(promiseArray).then((response) => {
          if (response.length === promiseArray.length) {
            resolve();
          }
        });
      });
    },
    initForm() {
      let roleInfo = this.roleInfo;
      if (roleInfo && roleInfo.roleId) {
        this.form = {
          roleName: roleInfo.roleName,
          roleCode: roleInfo.roleCode,
          roleLevel: roleInfo.roleLevel,
          roleScope: roleInfo.roleScope,
          userScope: roleInfo.userScope,
          projScope: roleInfo.projectScope,
          entityScope: roleInfo.componentScope,
          description: roleInfo.description,
          isDefault: roleInfo.isDefault,
        };
      }
    },
    submit() {
      this.$refs.form.validate((bool, object) => {
        if (!bool) {
          this.$message.error("表单验证失败，请正确填写相关内容后再重新提交");
          return;
        }

        if (this.roleInfo) {
          let params = this.getParams();
          params.id = this.roleInfo.roleId;
          updateRoleService(params).then((result) => {
            if (result.status === 200) {
              let response = result.data;
              if (response.isSuccess) {
                this.updateRoleList().then(() => {
                  this.$message.success("更新角色成功！！！");
                  this.cancel();
                });
              } else {
                this.$message.error(response.errMsg);
              }
            }
          });
        } else {
          let params = this.getParams();
          createRoleService(params).then((result) => {
            if (result.status === 200) {
              let response = result.data;
              if (response.isSuccess) {
                this.updateRoleList().then(() => {
                  this.$message.success("新建角色成功！！！");
                  this.cancel();
                });
              } else {
                this.$message.error(response.errMsg);
              }
            }
          });
        }
      });
    },
    getParams() {
      let params = {
        roleName: this.form.roleName,
        roleCode: this.form.roleCode,
        description: this.form.description,
        roleLevel: this.form.roleLevel,
        roleScope: this.form.roleScope,
        userScope: this.form.userScope,
        projectScope: this.form.projScope,
        componentScope: this.form.entityScope,
        isDefault: this.form.isDefault,
      };
      return params;
    },
    jumpToTeamManage() {
      this.$router.push("./teamManage");
    },
    isSuperAdmin() {
      let userInfo = Store.userInfo;
      let roleCode = userInfo.roleCode;
      return roleCode === "SuperAdmin";
    },
    queryRoleLevelList() {
      return new Promise((resolve) => {
        getRoleLevelListService().then((result) => {
          if (result.status === 200) {
            let response = result.data;
            if (response.isSuccess) {
              let roleLevelList = response.data;
              this.roleLevelList = roleLevelList;
              resolve();
            } else {
              this.$message.error(response.errMsg);
            }
          }
        });
      });
    },
    querRoleScopeList() {
      const tipMapArray = [
        {
          value: 1,
          displayName: "所有角色",
          tip: "显示系统定义的所有角色",
        },
        {
          value: 2,
          displayName: "子级角色",
          tip: "根据角色级别，显示比当前角色等级低的",
        },
        {
          value: 3,
          displayName: "无",
          tip: "系统内所有角色不可见",
        },
      ];
      return new Promise((resolve) => {
        getRoleScopeListService().then((result) => {
          if (result.status === 200) {
            let response = result.data;
            if (response.isSuccess) {
              let roleScopeList = response.data;
              roleScopeList = roleScopeList.map((item) => {
                let find = tipMapArray.find((el) => el.value === item.value);
                item.tip = find.tip;
                return item;
              });
              this.roleScopeList = roleScopeList;
              resolve();
            } else {
              this.$message.error(response.errMsg);
            }
          }
        });
      });
    },
    queryUserScopeList() {
      return new Promise((resolve) => {
        const tipMapArray = [
          {
            value: 1,
            displayName: "所有用户",
            tip: "系统内的所有用户",
          },
          {
            value: 2,
            displayName: "子级角色用户",
            tip: "根据角色级别，可管理比当前角色等级低的所有用户",
          },
          {
            value: 3,
            displayName: "子级用户",
            tip: "同一团队内的所有用户，自己创建的用户，默认隶属于自己的团队，参考： ",
          },
          {
            value: 4,
            displayName: "无",
            tip: "没有可管理的用户",
          },
        ];
        getUserScopeListService().then((result) => {
          if (result.status === 200) {
            let response = result.data;
            if (response.isSuccess) {
              let userScopeList = response.data;
              userScopeList = userScopeList.map((item) => {
                let find = tipMapArray.find((el) => el.value === item.value);
                item.tip = find.tip;
                return item;
              });
              this.userScopeList = userScopeList;
              resolve();
            } else {
              this.$message.error(response.errMsg);
            }
          }
        });
      });
    },
    queryProjScopeList() {
      return new Promise((resolve) => {
        const tipMapArray = [
          {
            value: 1,
            displayName: "所有项目",
            tip: "系统内的所有项目",
          },
          {
            value: 2,
            displayName: "子级用户项目",
            tip: "团队成员的所有项目，包含授权给自己的项目",
          },
          {
            value: 3,
            displayName: "仅授权项目",
            tip: "授权给自己可管理的项目，自己创建的项目默认授权给自己",
          },
        ];
        getProjScopeListService().then((result) => {
          if (result.status === 200) {
            let response = result.data;
            if (response.isSuccess) {
              let projScopeList = response.data;
              projScopeList = projScopeList.map((item) => {
                let find = tipMapArray.find((el) => el.value === item.value);
                item.tip = find.tip;
                return item;
              });
              this.projScopeList = projScopeList;
              resolve();
            } else {
              this.$message.error(response.errMsg);
            }
          }
        });
      });
    },
    clearForm() {
      this.form = {
        roleName: "",
        roleCode: "",
        roleLevel: undefined,
        roleScope: undefined,
        userScope: undefined,
        projScope: undefined,
        entityScope: undefined,
        isDefault: undefined,
        description: "",
      };
    },
    cancel() {
      this.clearForm();
      this.closeDialog();
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.common-form-box {
  color: var(--default-color);

  .no-distance{
    margin-bottom: 16px !important;
  }

  .edit-role{
    color: var(--roleManage-dialog-text-color);
    font-size: 14px;
    font-weight: 400;
  }

  :deep(.el-form-item){
    margin-bottom: 34px;

    .el-form-item__label{
      height: 32px;
      line-height: 32px;
    }

    .el-form-item__content{
      line-height: 32px;
    }

    .el-form-item__error{
      margin-top: 3px;
    }
  }

  .role_desc{
    // height: 122px;
    margin-bottom: 12px;
    :deep(.el-form-item__content){
      // height: 122px;
    }
  }
  .tip-box {
    position: absolute;
    top: 28px;
  }

  .common-input-box {
    position: relative;

    &:not(:only-child) {
      .tip-box {
        display: none;
      }
    }
  }

  .common-select-box {
    position: relative;
    .el-select {
      width: 100%;
    }

    .option-box {
      display: flex;

      .option-name {
        color: var(--default-color);
      }

      .option-tip {
        margin-left: 10px;
        color: var(--base-dark11-color);

        .option-link {
          color: var(--primary-color);
          cursor: pointer;
        }
      }
    }

    &:not(:only-child) {
      .tip-box {
        display: none;
      }
    }
  }
}
</style>